import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PatternOverlay from "@/components/PatternOverlay";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      const dest = loc.state?.from || (res.user?.role === "admin" ? "/admin" : "/account");
      nav(dest, { replace: true });
    } else setError(res.error);
  };

  return (
    <div className="pattern-bg max-w-md mx-auto px-6 py-24 md:py-32" data-testid="login-page">
      <PatternOverlay opacity={0.11} size={460} />
      <div className="text-xs uppercase tracking-[0.32em] text-primary">Welcome back</div>
      <h1 className="font-serif text-5xl mt-4 tracking-tight">Sign In</h1>
      <p className="mt-3 text-muted-foreground text-sm">
        Access your account, orders and wishlist.
      </p>

      <form onSubmit={submit} className="mt-10 space-y-6">
        <div>
          <label className="text-xs uppercase tracking-[0.28em] text-muted-foreground">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-primary text-foreground"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-[0.28em] text-muted-foreground">Password</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-primary text-foreground"
          />
        </div>

        {error && (
          <div className="text-destructive text-sm" data-testid="login-error">{error}</div>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full bg-primary text-primary-foreground uppercase tracking-[0.22em] text-sm py-4 hover:opacity-90 disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>

      <div className="mt-8 text-sm text-muted-foreground">
        New here?{" "}
        <Link to="/register" className="text-primary hover:opacity-80" data-testid="login-to-register">
          Create an account
        </Link>
      </div>
    </div>
  );
}
